import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { formattedDate } from "../../../../Common/helper/helpar";

export const MSWManagementTertiaryVehicleInnerExport = ({ data = [],fromDate,toDate }) => {
  const navigate = useNavigate();

  /* ================= FIXED KEYS ================= */
  const FIXED_KEYS = ["ZoneName", "StationName", "Status", "Type", "Sno","Remarks"];

  /* ================= DATE ================= */
  const getReportGeneratedOn = () => {
    const now = new Date();
  
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = String(now.getFullYear()).slice(-2); // last 2 digits
  
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
  
    return `Report Generated On : ${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };
  

  /* ================= DYNAMIC COLUMNS ================= */
  const dynamicColumns = useMemo(() => {
    if (!data.length) return [];
    return Object.keys(data[0]).filter(
      (key) => !FIXED_KEYS.includes(key)
    );
  }, [data]);

  /* ================= DYNAMIC TOTALS ================= */
  const dynamicTotals = useMemo(() => {
    return dynamicColumns.reduce((acc, col) => {
      acc[col] = data.reduce(
        (sum, row) => sum + Number(row[col] || 0),
        0
      );
      return acc;
    }, {});
  }, [dynamicColumns, data]);

  /* ================= EXCEL DOWNLOAD ================= */
  const downloadAsExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Tertiary Vehicle Inner Report");

    const bold = { bold: true };

    const headerText = `Detailed Equipment Deployment Data Report as on (${fromDate})`;

    // Title


    // Generated On
    worksheet.addRow([getReportGeneratedOn()]);
    worksheet.mergeCells(
      1,
      1,
      1,
      5 + dynamicColumns.length
    );
    worksheet.getCell("A1").alignment = { horizontal: "center" };
    worksheet.addRow([headerText]);
    worksheet.mergeCells(
      2,
      1,
      2,
      5 + dynamicColumns.length
    );
    worksheet.getCell("A2").font = bold;
    worksheet.getCell("A2").alignment = { horizontal: "center" };
    worksheet.addRow([]);
    

    /* ================= HEADERS ================= */
    const headers = [
      "S.No",
      "Zone",
      "Station",
      "Status",
      "Type",
      ...dynamicColumns,
      "Remarks",
    ];

    const headerRow = worksheet.addRow(headers);

    headerRow.eachCell((cell) => {
      cell.font = bold;
      cell.alignment = { horizontal: "center" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "F6B1B1" },
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    /* ================= DATA ROWS ================= */
    data.forEach((row, index) => {
      worksheet.addRow([
        index + 1,
        row.ZoneName || "N/A",
        row.StationName || "N/A",
        row.Status || "N/A",
        row.Type || "N/A",
        ...dynamicColumns.map((col) => row[col] ?? 0),
        row.Remarks || "N/A",
      ]);
    });

    /* ================= TOTAL ROW ================= */
    const totalRow = worksheet.addRow([
      "Total",
      "",
      "",
      "",
      "",
      ...dynamicColumns.map((col) => dynamicTotals[col]),
      "",
    ]);

    totalRow.eachCell((cell) => {
      cell.font = bold;
      cell.alignment = { horizontal: "center" };
    });

    worksheet.columns = headers.map(() => ({ width: 15 }));

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "MSW_Tertiary_Vehicle_Inner_Report.xlsx";
    link.click();
  };

  /* ================= PDF DOWNLOAD ================= */
  const downloadAsPDF = () => {
    const doc = new jsPDF("l", "mm", "a4");

    doc.setFontSize(14);
    doc.text(
      "Detailed Equipment Deployment Data Report",
      doc.internal.pageSize.getWidth() / 2,
      15,
      { align: "center" }
    );

    doc.setFontSize(10);
    doc.text(
      getReportGeneratedOn(),
      doc.internal.pageSize.getWidth() / 2,
      22,
      { align: "center" }
    );

    const columns = [
      "S.No",
      "Zone",
      "Station",
      "Status",
      "Type",
      ...dynamicColumns,
    ];

    const rows = data.map((row, index) => [
      index + 1,
      row.ZoneName || "N/A",
      row.StationName || "N/A",
      row.Status || "N/A",
      row.Type || "N/A",
      ...dynamicColumns.map((col) => row[col] ?? 0),
    ]);

    // TOTAL ROW
    rows.push([
      "Total",
      "",
      "",
      "",
      "",
      ...dynamicColumns.map((col) => dynamicTotals[col]),
    ]);

    autoTable(doc, {
      head: [columns],
      body: rows,
      startY: 30,
      styles: { fontSize: 8, halign: "center" },
      didParseCell: (data) => {
        if (data.row.index === rows.length - 1) {
          data.cell.styles.fontStyle = "bold";
        }
      },
    });

    doc.save("MSW_Tertiary_Vehicle_Inner_Report.pdf");
  };

  return (
    <>
      <button className="btn btn-secondary me-2" onClick={() => navigate(-1)}>
        Back
      </button>
{/* 
      <button className="btn btn-excel me-2" onClick={downloadAsPDF}>
        <i className="fa-solid fa-file-pdf me-1"></i> PDF
      </button> */}

      <button className="btn btn-excel" onClick={downloadAsExcel}>
        <i className="fa-solid fa-file-excel me-1"></i> Excel
      </button>
    </>
  );
};
